export function distanceFromTop(element) {
    return element.getBoundingClientRect().top;
}

export function distanceFromBottom(element) {
    return element.getBoundingClientRect().bottom;
}
